import React from "react";
import {BasketsUIProvider} from "./BasketsUIContext";
import BasketsListCmp from "./BasketsListCmp";

export default function Baskets() {
    return (
        <BasketsUIProvider>
            <BasketsListCmp/>
        </BasketsUIProvider>
    )
}